import { useEffect, useState, useRef } from 'react';

interface Counter {
  value: number;
  label: string;
  suffix: string;
}

const TrustCounters = () => {
  const [counters, setCounters] = useState<Counter[]>([
    { value: 0, label: 'Años de experiencia', suffix: '+' },
    { value: 0, label: 'Pisos vaciados', suffix: '+' },
    { value: 0, label: 'Casos de Diógenes', suffix: '+' },
    { value: 0, label: 'Servicio urgente', suffix: 'h' },
  ]);

  const targetValues = [10, 500, 200, 24];
  const sectionRef = useRef<HTMLDivElement>(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          animateCounters();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [hasAnimated]);

  const animateCounters = () => {
    const duration = 2000;
    const steps = 60;
    const stepDuration = duration / steps;

    let currentStep = 0;

    const interval = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;

      setCounters((prev) =>
        prev.map((counter, index) => ({
          ...counter,
          value: Math.floor(targetValues[index] * progress),
        }))
      );

      if (currentStep >= steps) {
        clearInterval(interval);
        setCounters((prev) =>
          prev.map((counter, index) => ({
            ...counter,
            value: targetValues[index],
          }))
        );
      }
    }, stepDuration);
  };

  return (
    <section ref={sectionRef} className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {counters.map((counter, index) => (
            <div
              key={index}
              className="text-center relative"
              style={{
                animation: hasAnimated ? `fadeInUp 0.6s ease-out ${index * 0.1}s both` : 'none',
              }}
            >
              {index > 0 && (
                <div className="hidden lg:block absolute left-0 top-1/2 transform -translate-y-1/2 w-px h-20 bg-gray-200"></div>
              )}
              <div className="text-5xl md:text-6xl font-extrabold text-primary mb-2">
                {counter.value}
                {counter.suffix}
              </div>
              <div className="text-dark text-base md:text-lg font-medium">{counter.label}</div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default TrustCounters;